import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["error", "submit"]

  connect() {
    // Check if there's a file input with required attribute
    this.fileInputs = this.element.querySelectorAll('input[type="file"][required]')
  }

  validateFile(event) {
    const fileInput = event.target
    if (fileInput.files && fileInput.files.length > 0) {
      this.hideError()
      return true
    } else {
      this.showError()
      return false
    }
  }

  validateBeforeSubmit(event) {
    let valid = true

    // Mark the form as validated
    this.element.classList.add('was-validated')

    // Check all required file inputs
    this.fileInputs.forEach(input => {
      if (!input.files || input.files.length === 0) {
        event.preventDefault()
        valid = false
        
        // Find the corresponding error element
        const controller = this.application.getControllerForElementAndIdentifier(
          input.closest('[data-controller="file-input"]'),
          'file-input'
        )
        
        if (controller) {
          const errorElement = controller.element.querySelector('[data-file-validation-target="error"]')
          if (errorElement) {
            errorElement.classList.remove('hidden')
          }
        } else {
          // Fallback to showing any error elements
          if (this.hasErrorTarget) {
            this.errorTarget.classList.remove('hidden')
          }
        }
      }
    })

    return valid
  }

  showError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.remove('hidden')
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.classList.add('hidden')
    }
  }
}